import { createContext, useContext } from 'react';

// A single shared context holding all app state + handlers. App.js provides the
// value; each screen reads what it needs via the useApp() hook below, so we
// don't have to thread dozens of props through every component.
export const AppContext = createContext(null);

export const useApp = () => useContext(AppContext);
